import { END_POINTS } from '../helpers';
import { Rating } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponseType = {
  statusCode: number;
  message: string;
  data: any;
  body: any;
  status: number;
};

type RatingResponse = {
  data: Rating[];
  count: number;
};

export const ratingApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRating: builder.query<
      CommonResponseType & { data: RatingResponse },
      { page: number; limit: number; search: string }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.rating}?page=${page}&limit=${limit}&search=${search}`,
        method: 'GET',
      }),
    }),

    updateRating: builder.mutation<CommonResponseType & { data: any }, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${END_POINTS.ratingUpdate}/${id}`,
        method: 'PUT',
        body,
      }),
    }),

    deleteRatingById: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.ratingDelete}/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useLazyGetRatingQuery, useUpdateRatingMutation, useDeleteRatingByIdMutation } =
  ratingApi;
